import { useCallback, useReducer } from 'react'

export const collapseKey = {
  general: 'general',
  contact: 'contact',
  address: 'address',
  employer: 'employer',
  social: 'social',
}

export const ActionType = {
  TOGGLE_COLLAPSE_GENERAL: 'TOGGLE_COLLAPSE_GENERAL',
  TOGGLE_COLLAPSE_CONTACT: 'TOGGLE_COLLAPSE_CONTACT',
  TOGGLE_COLLAPSE_ADDRESS: 'TOGGLE_COLLAPSE_ADDRESS',
  TOGGLE_COLLAPSE_EMPLOYER: 'TOGGLE_COLLAPSE_EMPLOYER',
  TOGGLE_COLLAPSE_SOCIAL: 'TOGGLE_COLLAPSE_SOCIAL',
}

const initialState = {
  general: true,
  contact: false,
  address: false,
  employer: false,
  social: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.TOGGLE_COLLAPSE_GENERAL:
      return {
        general: !state.general,
      }
    case ActionType.TOGGLE_COLLAPSE_CONTACT:
      return {
        contact: !state.contact,
      }
    case ActionType.TOGGLE_COLLAPSE_ADDRESS:
      return {
        address: !state.address,
      }
    case ActionType.TOGGLE_COLLAPSE_EMPLOYER:
      return {
        employer: !state.employer,
      }
    case ActionType.TOGGLE_COLLAPSE_SOCIAL:
      return {
        social: !state.social,
      }

    default:
      return state
  }
}

export default function useProfileDetailTab() {
  const [state, dispatch] = useReducer(reducer, initialState)

  const toggleCollapse = useCallback((collapseKey) => {
    switch (collapseKey) {
      case collapseKey.general:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_GENERAL,
        })
        break
      case collapseKey.contact:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_CONTACT,
        })
        break
      case collapseKey.address:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_ADDRESS,
        })
        break
      case collapseKey.employer:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_EMPLOYER,
        })
        break
      case collapseKey.social:
        dispatch({
          type: ActionType.TOGGLE_COLLAPSE_SOCIAL,
        })
        break

      default:
        break
    }
  }, [])

  return {
    state,
    toggleCollapse,
  }
}
